import apiClient, { getApiErrorMessage } from './apiClient';

const unwrapApiData = (data) => data?.data || data?.Data || data;
const unwrapApiList = (data) => {
  const unwrapped = unwrapApiData(data);
  if (Array.isArray(unwrapped)) return unwrapped;
  if (Array.isArray(unwrapped?.items)) return unwrapped.items;
  if (Array.isArray(unwrapped?.Items)) return unwrapped.Items;
  return [];
};

export const normalizeRecentItem = (item) => ({
  id: item?.Id || item?.id,
  type: `${item?.Type || item?.type || ''}`.toLowerCase(),
  title: item?.Title || item?.title || '',
  updatedAt: item?.UpdatedAt || item?.updatedAt || new Date().toISOString(),
  isPinned: Boolean(item?.IsPinned ?? item?.isPinned),
  isArchived: Boolean(item?.IsArchived ?? item?.isArchived),
  folderId: item?.FolderId || item?.folderId || null,
  isTemporary: Boolean(item?.IsTemporary ?? item?.isTemporary)
});

export const fetchRecentActivityApi = async (take = 100) => {
  try {
    const { data } = await apiClient.get('/activity/recent', { params: { take } });
    return unwrapApiList(data).map(normalizeRecentItem).filter((item) => item.id);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load recent activity.'));
  }
};

export const updateRecentActivityApi = async (
  type,
  id,
  { title, isPinned, isArchived, folderId, clearFolder } = {}
) => {
  try {
    const payload = {};
    if (title !== undefined) payload.Title = title;
    if (isPinned !== undefined) payload.IsPinned = isPinned;
    if (isArchived !== undefined) payload.IsArchived = isArchived;
    if (folderId !== undefined) payload.FolderId = folderId;
    if (clearFolder) payload.ClearFolder = true;
    const { data } = await apiClient.patch(
      `/activity/${encodeURIComponent(type)}/${encodeURIComponent(id)}`,
      payload
    );
    return normalizeRecentItem(unwrapApiData(data));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to update item.'));
  }
};

export const deleteRecentActivityApi = async (type, id) => {
  try {
    await apiClient.delete(`/activity/${encodeURIComponent(type)}/${encodeURIComponent(id)}`);
    return id;
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to delete item.'));
  }
};
